<template>
  <div class="w-90">
    <b-card bg-variant="light">
      <!-- <vuex-breadcrumb></vuex-breadcrumb> -->
      <h1 id="jump-to-header">{{heading || "Update Interest"}}</h1>
      <b-tabs
          active-nav-item-class="font-weight-bold text-uppercase text-warning"
          active-tab-class="font-weight-bold text-success"
          content-class="mt-3"
          lazy
        >
          <b-tab title="Settings" active>
            <interest-update :id="id" @gotAttrs="assignAttrs"></interest-update>
          </b-tab>
          <b-tab title="Product Models">
            <product-model-index
              :filtering="filtering"
              :ams_template="ams_template"
            ></product-model-index>
          </b-tab>
          <b-tab title="Information">
            <poly-integer-reference-index
              :filtering="filtering"
              :ams_template="ams_template_reference"
            ></poly-integer-reference-index>
          </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
// import VuexBreadcrumb from './VuexBreadcrumb.vue'
import InterestUpdate from './InterestUpdate.vue'
import ProductModelIndex from './ProductModelIndex.vue'
import PolyIntegerReferenceIndex from './PolyIntegerReferenceIndex.vue'

export default {
  components: {
    // VuexBreadcrumb,
    InterestUpdate,
    ProductModelIndex,
    PolyIntegerReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        reference_to_id: this.id,
        reference_to_type: 'Interest'
      },
      attrs: {},
      ams_template_reference: {
        type: 'poly-integer-references',
        description: "Interest Description",
        attributes: {
          'reference-to-type': "Interest",
          'reference-to-id': this.id
        }
      },
      ams_template: {
        type: 'product-models',
        description: undefined,
        attributes: {
          'interest-id': this.id
        }
      },
    }
  },
  methods: {
    assignAttrs(attrs) {
      this.attrs = Object.assign( {}, attrs)
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>